import { Button } from "@/components/ui/button";
import { Check, ArrowRight, Gift } from "lucide-react";

const features = [
  "Your personalized QCard profile",
  "Photo, name, title & company",
  "Phone, email & website links",
  "All your social media profiles",
  "Instant 'Add to Contacts' button",
  "Shareable QR code",
  "Personal link (qcard.me/you)",
  "Unlimited sharing",
];

const FreeTierSectionV2 = () => {
  return (
    <section className="py-24 bg-qcard-dark relative overflow-hidden">
      {/* Background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-green-500/5 rounded-full blur-[150px]" />
      
      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-500/20 text-green-400 text-sm font-semibold mb-4 border border-green-500/30">
              <Gift className="w-4 h-4" />
              Free Forever
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              Free. Forever.{" "}
              <span className="text-primary">No Excuses.</span>
            </h2>
            <p className="text-lg text-white/50 max-w-2xl mx-auto">
              Other digital card companies charge $10-20/month for basic features. 
              We give you everything for <span className="text-white font-semibold">$0</span>.
            </p>
          </div>

          {/* Pricing Card */}
          <div className="relative">
            {/* Glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 via-primary/20 to-green-500/20 rounded-3xl blur-2xl" />
            
            <div className="relative bg-slate-900/80 backdrop-blur-sm rounded-3xl border border-white/10 overflow-hidden">
              {/* Header */}
              <div className="bg-gradient-to-r from-green-600 to-green-500 px-8 py-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-green-100 text-sm mb-1">QCard Free</p>
                    <div className="flex items-baseline gap-2">
                      <span className="text-5xl font-bold text-white">$0</span>
                      <span className="text-green-100">/forever</span>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-green-200/60 text-sm line-through">$12/month</p>
                    <p className="text-white font-semibold">Save $144/year</p>
                  </div>
                </div>
              </div>

              {/* Features */}
              <div className="p-8">
                <div className="grid sm:grid-cols-2 gap-4 mb-8">
                  {features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
                        <Check className="w-4 h-4 text-green-400" />
                      </div>
                      <span className="text-white/80">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <div className="text-center">
                  <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-12 py-6 font-semibold shadow-lg shadow-primary/30">
                    Get Your Free QCard
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                  <p className="mt-4 text-sm text-white/40">
                    No credit card required. Set up in 60 seconds.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom note */}
          <div className="mt-8 text-center">
            <p className="text-white/40 text-sm">
              No hidden fees. No "premium" upsells for basic features. Just QCard.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeTierSectionV2;
